import { addListener, Action, ThunkAction } from '@reduxjs/toolkit';

// Copied from @reduxjs/toolkit because 2.2.6 was the last version that exported this
// We'd probably be better off with some else type.
interface TypedActionCreator<Type extends string> {
  (...args: any[]): Action<Type>;
  type: Type;
  match: MatchFunction<any>;
}
type MatchFunction<T> = (v: any) => v is T;

/**
 * Helper thunk that waits for the certain action to be dispatched next time.
 * Returns a promise that resolves when the action is next time dispatched,
 * resolving to that action.
 *
 * This action requires both thunk and listener middlewares in order to work!
 *
 * @param actionCreator creator for the action to wait for
 * @returns promise that resolves to the next action of the given type
 */
export default function waitForActionDispatch<State, Creator extends TypedActionCreator<any>>(
  actionCreator: Creator,
): ThunkAction<Promise<ReturnType<Creator>>, State, unknown, Action<string>> {
  return async (dispatch) =>
    new Promise<ReturnType<Creator>>((resolve) => {
      // Dispatch a listener for the initialization action
      const unsubscribe = dispatch(
        addListener({
          actionCreator,
          effect(action) {
            unsubscribe();
            resolve(action);
          },
          // The return type of dispatch(addListener(…)) is wrong!
          // It is actually a function. Force-casting it to the correct type.
        }),
      ) as unknown as () => void;
    });
}
